import { getPrivateMessagesUsers, PRIVATE_MESSAGE_EVENTS } from '@moal/api'
import { useContext, useEffect, useReducer, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useNavigate } from 'react-router-dom'
import {
  allUsersReducer,
  initialState
} from '../../../../reducers/allUsersReducer'
import { ErrorRow, LoadedAllRow, LoadingRow, UserRow } from '../UserRows'

import {
  EDIT_USER,
  ERROR,
  HAS_MORE,
  LOADING,
  SET_USERS
} from '../../../../constants/actions/allUsersActions'
import { SocketContext } from '../../../../context/socketContext'

const AllUsers = ({ fetchUserCounts, handlePinnedUserClick, searchId }) => {
  const { privateMessagesSocket: socket } = useContext(SocketContext)
  const navigate = useNavigate()
  const [state, dispatch] = useReducer(allUsersReducer, initialState)
  const [search, setSearch] = useState(searchId || '')

  useEffect(() => {
    if (search) {
      loadUsers(true, search)
    } else {
      loadUsers()
    }
  }, [search])

  useEffect(() => {
    if (!socket) return
    socket.on(PRIVATE_MESSAGE_EVENTS.UPDATE_USER, handleUpdateUser)
    return () => {
      socket.off(PRIVATE_MESSAGE_EVENTS.UPDATE_USER, handleUpdateUser)
    }
  }, [socket])

  const loadUsers = async (reset = false, search = null) => {
    const response = await getPrivateMessagesUsers({
      token: localStorage.getItem('authToken'),
      loadMore:
        state.users.length > 0 && !reset
          ? `${state.users[state.users.length - 1].lowerName}`
          : '',
      search: search
    })
    if (response && response.status === 200) {
      fetchUserCounts()
      if (response.data.length > 0) {
        if (search && response.data.length === 1) {
          navigate(
            `us/${response.data[0].userService._id}/pm/${response.data[0]._id}`,
            {
              replace: true
            }
          )
        }

        if (reset) {
          dispatch({ type: SET_USERS, payload: response.data })
        } else {
          dispatch({
            type: SET_USERS,
            payload: [...state.users, ...response.data]
          })
        }
      } else {
        dispatch({ type: HAS_MORE, payload: false })
      }
    } else {
      dispatch({ type: ERROR, payload: true })
    }
    dispatch({ type: LOADING, payload: false })
  }

  const togglePinnedUser = (pmUserId) => {
    const user = state.users.find((user) => user._id === pmUserId)
    handlePinnedUserClick(user, () => {
      loadUsers(true)
    })
  }

  const handleUpdateUser = (data) => {
    dispatch({ type: EDIT_USER, payload: data })
  }

  if (state.loading) {
    return <LoadingRow />
  }
  if (state.error) {
    return <ErrorRow />
  }

  return (
    <div className="flex flex-col overflow-y-hidden w-full h-full gap-2">
      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="input block w-full"
        placeholder="Search"
      />
      <div id="userList" className="overflow-y-auto w-full h-full ">
        <InfiniteScroll
          dataLength={state.users.length}
          next={loadUsers}
          className="flex flex-col overflow-y-auto gap-1 w-full h-full"
          scrollableTarget="userList"
          loader={<LoadingRow />}
          endMessage={<LoadedAllRow />}
          hasMore={state.hasMore}
        >
          {state.users.map((user) => {
            return (
              <UserRow
                key={user._id}
                user={user}
                togglePinned={togglePinnedUser}
                allUsers
              />
            )
          })}
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default AllUsers
